import {
  Component,
  OnInit,
  ViewContainerRef,
  ComponentFactoryResolver
} from "@angular/core";
import { StoryHubService } from "./story-hub-listing.service";
import { NgxMasonryOptions } from 'ngx-masonry';
import { Response } from "projects/shared/models/Response";
import { Globals } from "projects/shared/models/Globals";
import { GenericListingComponent } from "projects/shared/components/genericListing.component";
import { MainPortalService } from "../../services/main-portal.service";
import { MediaHubFilterationCriteria } from "../../contracts/media-hub/MediaHubFilterationCriteria";
import { MediaHubPagedResult } from "../../contracts/media-hub/MediaHubPagedResult";

declare var filterationObj: any;
declare var selectList: any;
declare var storyCategory: any;
declare var isChild: any;
declare var $: any;

@Component({
  selector: "app-story-hub",
  templateUrl: "../../../../../shared/templates/general-media-landing-template.html",
  providers: [StoryHubService],
  styleUrls: []
})
export class StoryHubComponent extends GenericListingComponent
  implements OnInit {
  EgyptianTreasureSelectList: any = selectList;
  StoryCategoryList: any = storyCategory;
  ViewLocalizedResources = Globals.ViewLocalizedResources;
  globals=Globals;
  targetComponents = "";
  noItems = false;
  filter = false;
  Filteration: MediaHubFilterationCriteria = {
    containsStringValue: null,
    nodeId: Number(filterationObj.nodeId),
    mediaType:  [
			{ name: this.ViewLocalizedResources.All, value: "all", icon: "icon-molecular", checked: true },
			{ name: this.ViewLocalizedResources.Images, value: "imageExtended", icon: "icon-picture", checked: false },
			{ name: this.ViewLocalizedResources.Video, value: "videoYoutube", icon: "icon-video-player", checked: false },
			{ name: this.ViewLocalizedResources.DModel, value: "dModel", icon: "icon-d", checked: false },
			{ name: this.ViewLocalizedResources.Image360, value: "image360", icon: "icon-degrees", checked: false },
			{ name: this.ViewLocalizedResources.Audio, value: "audio", icon: "icon-speaker", checked: false },
			{ name: this.ViewLocalizedResources.Article, value: "article", icon: "icon-file", checked: false },
			{ name: this.ViewLocalizedResources.CustomMedia, value: "customMediaItem", icon: "icon-file", checked: false },
    ],
    isSocial: null,
    isChild: isChild
  };
  AppliedFilteration: MediaHubFilterationCriteria;
  constructor(
    private data: MainPortalService,
    protected service: StoryHubService,
    public componentFactoryResolver: ComponentFactoryResolver,
    public viewContainerRef: ViewContainerRef
  ) {
    super();
    this.isStory = true;
    this.createFilter();
    this.getItems(false);
  }

  public masonryOptions: NgxMasonryOptions = {
    originLeft:  Globals.Culture == "en"
  };
  // @ViewChild("dialogComponentContainer", { read: ViewContainerRef })
  // dialogComponentContainer: ViewContainerRef;
  componentRef: any;

  selectedIndex: any;
  mediaItems2: any;

  openDialog(selectedIndex: any, items: any) {
    // this.mediaItems2 = items;
    this.selectedIndex = selectedIndex;
    $("#exampleModal").modal();
    // this.data.item = item;
    // this.data.items = items;

    // debugger;
    // if (this.componentRef) this.componentRef.destroy();

    // const factory = this.componentFactoryResolver.resolveComponentFactory(
    //   DialogViewerComponent
    // );
    // this.componentRef = this.dialogComponentContainer.createComponent(factory);
  }
  ngOnInit() {}

  getPage(param, isScroll) {
    param.isStory = true;
    param.pageSize=9;
    this.noItems=false;
    this.service
      .GetStoryHubsPage(param)
      .subscribe(
        (response: Response<MediaHubPagedResult>) => {
					this.onSuccess(response, isScroll)
          console.log(response),
          this.noItems = this.array.length == 0
          this.mediaItems2=this.array;
				},
				(response: any) => this.onError(response)
      );
  }

  
	setBaseValues(){		
    this.Filteration.mediaType[0].checked = true;
		this.Filteration.mediaType[1].checked = this.Filteration.mediaType[2].checked =
		this.Filteration.mediaType[3].checked = this.Filteration.mediaType[4].checked = 
		this.Filteration.mediaType[5].checked = this.Filteration.mediaType[6].checked = 
		this.Filteration.mediaType[7].checked = false;
  }

	onSelectionChange($event) {
		var checked = this.Filteration.mediaType.filter(opt => opt.checked).length;
		if($event.currentTarget.value == this.Filteration.mediaType[0].name)
			this.setBaseValues();
		else if(checked > 1)
			this.Filteration.mediaType[0].checked = false;
		else if (checked == 0)
			this.Filteration.mediaType[0].checked = true;

    this.filter = true;	
		//this.onFilter();

		setTimeout(() => {

		}, 1500)
		// $grid.isotope('reloadItems');
	}
  onFilter() {
    super.onFilter();
    this.showFilterationCount = true;
  }
  resetFilter(event) {
    this.setBaseValues();
		this.showFilterationCount = false;
		this.Filteration.containsStringValue = this.AppliedFilteration.containsStringValue = null;
		this.Filteration.nodeId = this.AppliedFilteration.nodeId = Number(this.EgyptianTreasureSelectList[0].nodeId);
		this.Filteration.isSocial = this.AppliedFilteration.isSocial = null;
    this.resetListing();
    this.getItems(false);
		return false;
  }
  createFilter() {
    if (this.Filteration.nodeId === undefined) {
      this.Filteration.nodeId = filterationObj.nodeId;
    }
    this.AppliedFilteration = new MediaHubFilterationCriteria(this.Filteration);
  }

  setReflectedIndex($event){
		this.selectedIndex=$event;
  }
  
  reflectPopupShowMore(){
		if(this.displayShowMoreButton)
		super.onShowMore();
	}
}
